// ─── brand ───────────────────────────────────────────────────────────────────
// The infra slug is `voicebox` (worker name, domain, CI) and stays put. The
// consumer-facing name of THIS app lives only here — change BRAND to rebrand the
// webapp without touching anything else. The service keeps its own copy in
// `shared/brand.ts`; a client is allowed to be branded differently from the
// service it calls, so the two are deliberately not the same file.

export const BRAND = {
  name: 'Convosense',
  wordmark: 'CONVOSENSE',
  tagline: 'talk to it, watch it talk back',
} as const
